module.exports = __webpack_public_path__ + "img/type--3-spans--multiple-lang--fr.b1234f87.jpg";